import { render, staticRenderFns } from "./Contratistas.vue?vue&type=template&id=63615103&scoped=true"
import script from "./Contratistas.vue?vue&type=script&lang=js"
export * from "./Contratistas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63615103",
  null
  
)

export default component.exports